











































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import loginForm from './components/LoginForm.vue'
import registerForm from './components/RegisterForm.vue'
import forgotForm from './components/ForgotPassword.vue'
import resetForm from './components/ResetPassword.vue'
import { setSessionStorage } from '@/store/src/utils/index'
const loginerModule = namespace('loginer')
interface LoginParams {
	userName: string,
	password: string
}
interface RegisterParams {
	userName: string,
	phone: string,
	code: string
}
interface ResetParams {
	password: string,
	passwordAgain: string,
	code: string
}
@Component({
	components: {
		loginForm,
		registerForm,
		forgotForm,
		resetForm
	}
})
export default class Login extends Vue {
	@loginerModule.Mutation('SET_LOGINER') private setLoginer!: any
	private formVisible: string = 'login'
	private resetPasswordPhone: string = ''
	private created () {
		setSessionStorage('loginUrl', '/z5')
	}
	private onLogin (loginParams: LoginParams): void {
		const params = {
			user: loginParams.userName,
			pass: loginParams.password,
			enforce: true,
			client: 'pc'
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/loginByUserNameAndPassword',
			data: params
		}).then((res: any) => {
			this.setLoginer({
				loginerUserName: loginParams.userName,
				loginerId: res.id,
				loginerName: res.nick_name,
				loginerTel: res.telephone,
				loginerEmail: res.email
			})
			this.$router.replace({ path: 'main/home' })
		})
	}
	private onRegister (registerParams: RegisterParams): void {
		const params = {
			company: registerParams.userName,
			telephone: registerParams.phone,
			code: registerParams.code,
			client: 'pc'
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/register',
			data: params
		}).then((res: any) => {
			this.setLoginer({
				loginerId: res.id,
				loginerName: res.nick_name,
				loginerTel: res.telephone,
				loginerEmail: res.email
			})
			this.$router.replace({ path: 'main/home' })
		})
	}
	private onRegisterClick (): void {
		this.formVisible = 'register'
	}
	private onLoginClick (): void {
		this.formVisible = 'login'
	}
	private onForgoPasswordClick (): void {
		this.formVisible = 'forgot'
	}
	private onSubmitPhone (phone: string): void {
		return (this as any).$fxHttp.requestGet({
			url: `/business/authentication/mobile/${phone}`
		}).then((res: any) => {
			this.formVisible = 'resetPassword'
			this.resetPasswordPhone = phone
		})
	}
	private onResetPassword (resetParams: ResetParams): void {
		const params = {
			newPassword:  resetParams.password,
			vCode: resetParams.code,
			telephone: this.resetPasswordPhone
		}
		return (this as any).$fxHttp.requestPost({
			url: `/business/resetPassword`,
			data: params
		}).then((res: any) => {
			this.$message.success('重置密码成功')
			this.formVisible = 'login'
		})
	}
}
